// Capture policy and timing constants shared by the voice controller,
// session and barge-in. The controller owns commit and idle transitions;
// this policy contains only the capture fields it consumes.
//
// Voice mode never stops itself on silence (the idle exits below end voice
// mode, not a turn) and never commits text a person did not hand over: a
// a tap commits, and in hands-free the provider's end
// of turn does, subject to the auto-send guards (./guards.ts).
import { VOICE_ACTIVITY_LEVEL } from '@/speech/capture/level';
import type { InteractivePolicy } from '@/speech/interactive/policy';

export const VOICE_POLICY: Pick<InteractivePolicy, 'micKind' | 'voiceActivityLevel'> =
  Object.freeze({
    micKind: 'voice',
    voiceActivityLevel: VOICE_ACTIVITY_LEVEL,
  });

/** G2: a semantic endpoint with any provider-recognized word may auto-send. */
export const ENDPOINT_MIN_WORDS = 1;
/** The open turn's frames are kept in memory for a replay, at most this long. */
export const OPEN_TURN_RING_MS = 60_000;
/** A session rolls over at the first turn boundary this long before its cap. */
export const ROLLOVER_MARGIN_SEC = 60;
/** Wait at most this long for `committed` after `commit` (the server waits ≤ 3 s itself). */
export const VOICE_COMMIT_TIMEOUT_MS = 8_000;
/** Echo projection removes playback; use the normal microphone speech floor. */
export const BARGE_IN_LEVEL_FACTOR = 1;
/** Half duplex: the microphone stays gated this long after the output latency. */
export const ECHO_TAIL_MS = 300;
/** A voice-turn body armed for the next send expires after this long. */
export const TURN_BODY_TTL_MS = 15_000;
/** Undo windows a person can pick, in milliseconds (C2-3: 0.5 to 10 s). */
export const UNDO_CHOICES_MS = Object.freeze([500, 1000, 2000, 3000, 5000, 10_000]);
